// extracted by mini-css-extract-plugin
module.exports = {"container":"left-side__container___FyPv3","count":"left-side__count___1itxG","button":"left-side__button___1bL_Y"};